import type { ReactNode } from "react";

import styles from "./Section.module.css";

type SectionProps = {
  id?: string;
  eyebrow?: string;
  title: string;
  subtitle?: string;
  children: ReactNode;
  className?: string;
  dark?: boolean;
};

function join(...parts: (string | undefined)[]): string {
  return parts.filter(Boolean).join(" ");
}

export function Section({
  id,
  eyebrow,
  title,
  subtitle,
  children,
  className,
  dark,
}: SectionProps) {
  return (
    <section
      id={id}
      className={join(
        styles.section,
        dark ? styles.dark : undefined,
        className,
      )}
    >
      <div className={styles.inner}>
        {eyebrow ? <p className={styles.eyebrow}>{eyebrow}</p> : null}
        <h2 className={styles.title}>{title}</h2>
        {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
        {children}
      </div>
    </section>
  );
}
